(() => {
  "use strict";

  const ROOT_SELECTOR = "[data-wsnz-collection]";

  function init(root = document) {
    root.querySelectorAll(ROOT_SELECTOR).forEach((section) => {
      if (section.dataset.ready === "1") return;
      section.dataset.ready = "1";

      mountReveal(section);
      mountSort(section);
    });
  }

  function mountReveal(section) {
    const nodes = [...section.querySelectorAll("[data-wsnz-reveal]")];

    if (!("IntersectionObserver" in window)) {
      nodes.forEach((node) => node.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: "0px 0px -8% 0px"
    });

    nodes.forEach((node, index) => {
      node.style.transitionDelay = `${Math.min(index * 45, 220)}ms`;
      observer.observe(node);
    });
  }

  function mountSort(section) {
    const select = section.querySelector("[data-collection-sort]");
    if (!select) return;

    select.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      window.location.assign(url.toString());
    });
  }

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
